import { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Analytics } from "@vercel/analytics/react";

import LoginPage from "./pages/LoginPage/LoginPage";
import ExplorerPage from "./pages/ExplorerPage/ExplorerPage";
import SharePage from "./pages/SharePage/SharePage";
import BundleSharePage from "./pages/BundleSharePage/BundleSharePage";
import BundlePage from "./pages/BundlePage/BundlePage";
import PdfViewerPage from "./pages/PdfViewerPage/PdfViewerPage";

import "./App.css";

function AppRouter() {
    const { user, loading } = useAuth();
    const path = window.location.pathname;
    const [view, setView] = useState("explorer");

    if (path.startsWith("/share/")) {
        return <SharePage />;
    }

    if (path.startsWith("/bundle/")) {
        return <BundleSharePage />;
    }

    if (loading) {
        return <div className="splash">Loading…</div>;
    }

    if (!user) {
        return <LoginPage />;
    }

    const pdfViewerMatch = path.match(/^\/files\/([^/]+)\/view\/?$/);

    if (pdfViewerMatch) {
        const fileId = pdfViewerMatch[1];

        return (
            <PdfViewerPage
                fileId={fileId}
                onBack={() => {
                    window.history.back();
                }}
                onNavigateFolder={(folderId) => {
                    if (folderId) {
                        window.location.href = `/files?folder=${folderId}`;
                    } else {
                        window.location.href = "/files";
                    }
                }}
            />
        );
    }

    if (view === "bundles") {
        return <BundlePage onBack={() => setView("explorer")} />;
    }

    return <ExplorerPage onViewBundles={() => setView("bundles")} />;
}

export default function App() {
    return (
        <>
            <Analytics />
            <AuthProvider>
                <AppRouter />
            </AuthProvider>
        </>
    );
}
